/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { default_server } from "./../../services/api";
import TweenOne from "rc-tween-one";
import Drawer from "react-drag-drawer";
import "./../../assets/styles/BookDetail.css";
import Copyrights from "../copyrights";
import { playSong, pauseSong } from '../../utils/song'
import songsName from "../../enums/songsName";
import { useNetworkStatus } from "../../hooks/useNetworkStatus";
import Spinner from "../spinner";
import { PRODUCT } from "../../consts/product";
import Button from "../button";
import OutlineButton from "../outline-button";

const BookDetail = props => {
  let BOOK = 0;

  const { isOnline } = useNetworkStatus()

  const isSurprise = props.appState === "firsttimevisit" ? true : false;
  const currentBookID = props.currentBookID;
  for (let i = 0; i < props.payload.listData.length; i++) {
    const element = props.payload.listData[i];
    if (element.bookId === currentBookID) {
      BOOK = i;
    }
  }

  const TOKEN = props.payload.token;
  const ITEM = props.payload.listData[BOOK];
  const GENDER = ""; //ITEM.bookAuthorGender === "F"? "Autora: " : "Autor: "
  const ILLUSTRATOR =
    ITEM.bookIllustrator.trim() === ITEM.bookAuthor.trim()
      ? ""
      : ITEM.bookIllustrator || "";
  const AUTHOR = ITEM.bookAuthor || "";
  const TITLE = ITEM.bookTitle || "";
  const content = `${GENDER} ${AUTHOR} \n  ${ILLUSTRATOR} `;

  const [show_download, toggle_download] = useState(false);

  const axios = require("axios");
  const postDownloadCounter = type => {
    axios.post(
      `${default_server}/quembaixou`,
      {
        livro: TITLE,
        token: TOKEN,
        produto: PRODUCT,
        tipo: type
      },
      {
        timeout: 10000,
        headers: {
          "Content-Type": "application/json"
        }
      }
    );
  };

  return (
    <TweenOne
      paused={isSurprise}
      animation={{ opacity: 1 }}
      id="book_detail"
      className={`book_detail_container`}
    >
      <p className="book_detail_infos">
        <p className="text-center text-yellow font-bold">{TITLE}</p>
        <p className="text-white">{content}</p>
      </p>

      <div className="flex flex-col justify-center items-center w-full px-4">
        {/* <button
          id="how-to-read"
          disabled={(!isOnline && !props.offlineBooksIds?.includes(currentBookID)) || props.openingBookId}
          onMouseEnter={() => {
            playSong(songsName.TAP)
          }}
          onClick={() => {
            if (props.openingBookId) {
              return
            }

            if (!props.isLoggedIn) {
              props.showExpanded()

              return
            }

            playSong(songsName.TAP)
            playSong(songsName.BUBBLES)
            props.changeReader(ITEM);
            postDownloadCounter(2);
          }}
        >
          Ler livro
        </button> */}

        <Button
          disabled={(!isOnline && !props.offlineBooksIds?.includes(currentBookID)) || props.openingBookId}
          onClick={() => {
            if (props.openingBookId) {
              return
            }

            if (!props.isLoggedIn) {
              props.showExpanded()

              return
            }

            playSong(songsName.TAP)
            playSong(songsName.BUBBLES)
            props.changeReader(ITEM);
            postDownloadCounter(2);
          }}
        >
          Ler livro
        </Button>

        <div className="w-full h-14 mt-2">
          {window.in_native_app ? (
            <OutlineButton
              loading={props.downloadingBooksIds?.includes(currentBookID)}
              onClick={async () => {
                playSong(songsName.TAP)

                if (!props.isLoggedIn) {
                  props.showExpanded()
    
                  return
                }

                pauseSong(songsName.MAIN_BACKGROUND)
                playSong(songsName.DOWNLOAD)

                props.downloadBook(currentBookID, ITEM)

                setTimeout(() => {
                  playSong(songsName.MAIN_BACKGROUND)
                }, 5000);
              }}
              onMouseEnter={() => {
                playSong(songsName.TAP)
              }}
              disabled={!(isOnline && !props.offlineBooksIds?.includes(currentBookID))}
            >
              {props.offlineBooksIds?.includes(currentBookID) ? "Baixado" : "Baixar"}
            </OutlineButton>
          ) : null}
        </div>
      </div>

      <Drawer dontApplyListeners={true} open={show_download}>
        <Copyrights />
      </Drawer>
    </TweenOne>
  );
};

export default BookDetail;
